import { IntlShape } from 'react-intl'

import { zonedTimeToUtc } from 'date-fns-tz'

import { Episode } from '../../../models/episodes/Episodes'

interface NextSessionInput {
  startDate: string
  startTime: string
  timeZone: string
}

export const useGetNextSessionSummary = (
  nextSession: NextSessionInput | undefined | null,
  selectedEpisode: Episode | undefined,
  intl: IntlShape,
  providerTimeZone: string,
) => {
  const nextSessionSummaryDetails = []

  // Format next session datetime
  if (nextSession && nextSession.startDate && nextSession.startTime && nextSession.timeZone) {
    const sessionDateTime = zonedTimeToUtc(`${nextSession.startDate} ${nextSession.startTime}`, nextSession.timeZone)
    const nextSessionFormatted = intl.formatDate(sessionDateTime, {
      timeZone: providerTimeZone,
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      timeZoneName: 'short',
    })
    nextSessionSummaryDetails.push({
      label: intl.formatMessage({
        defaultMessage: 'Next session',
        description: 'Label for next session in summary details',
      }),
      value: nextSessionFormatted,
    })
  }

  // Format episode start date
  if (selectedEpisode?.start_date) {
    const startDate = new Date(selectedEpisode?.start_date)
    const startDateFormatted = intl.formatDate(startDate, {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    })
    nextSessionSummaryDetails.push({
      label: intl.formatMessage({
        defaultMessage: 'Start date',
        description: 'Label for episode start date in summary details',
      }),
      value: startDateFormatted,
    })
  }

  if (selectedEpisode?.state) {
    let episodeStatus = ''
    switch (selectedEpisode?.state) {
      case 'completed':
        episodeStatus = 'Completed'
        break
      case 'in_progress':
        episodeStatus = 'Active'
        break
      case 'drop_out':
        episodeStatus = 'Drop Out'
        break
      case 'not_supported':
        episodeStatus = 'Not Supported'
        break
      case 'care_transition':
        episodeStatus = 'Care Transition'
        break
      case 'not_initiated':
        episodeStatus = 'Not Initiated'
        break
      case 'not_eligible':
        episodeStatus = 'Not Eligible'
        break
      case 'booster':
        episodeStatus = 'Booster'
        break
    }

    if (episodeStatus !== '') {
      nextSessionSummaryDetails.push({
        label: intl.formatMessage({
          defaultMessage: 'Status',
          description: 'Label for episode status in summary details',
        }),
        value: episodeStatus,
      })
    }
  }

  return nextSessionSummaryDetails
}
